import { LoggerService } from "@akashnetwork/logging";

export const sdkLogger = new LoggerService({
  name: "http-sdk"
});
